import { Navigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { INTERVIEW_BOT_COMPANY_IDS } from "../view/user/nipponBot/constants";

const interactionLandingCompanies = [
  "67e560a6ae2e0d3f96b5eb09",
  "69ba88379b1aea31bda6224e"
];

const getDefaultRouteForUser = (decodedToken) => {
  if (decodedToken?.userRole == "SuperAdmin")
    return "/super-admin/process-management";

  if (
    (decodedToken?.userRole === "Admin" ||
      decodedToken?.userRole === "Manager") &&
    interactionLandingCompanies.includes(decodedToken?.companyId)
  ) {
    return "/user/audio-details";
  }

  if (
    decodedToken?.userRole === "Curator" &&
    INTERVIEW_BOT_COMPANY_IDS.includes(decodedToken?.companyId)
  ) {
    return "/user/bot-interviews";
  }

  if (decodedToken?.userRole == "Admin")
    return "/user/dashboard";
  if (decodedToken?.userRole == "Manager")
    return "/user/dashboard";
  if (decodedToken?.userRole == "BranchManager")
    return INTERVIEW_BOT_COMPANY_IDS.includes(decodedToken?.companyId)
      ? "/user/bot-interviews/branch-candidates"
      : "/user/audio";
  if (decodedToken?.userRole == "Guest")
    return "/demo/audio/upload-file";
  if (decodedToken?.userRole == "QualityAnalyst")
    return "/user/dashboard";
  if (decodedToken?.userRole == "Agent")
    return "/agent/dashboard";
  if (decodedToken?.userRole == "Curator")
    return "/user/audio-details";

  return "/demo/audio/upload-file";
};

const getProtectedFallback = (location, decodedToken) => {
  const fromPath = location.state?.from?.pathname;
  const defaultPath = getDefaultRouteForUser(decodedToken);

  return fromPath && fromPath !== location.pathname ? fromPath : defaultPath;
};

export const ProtectedRoute = ({ element, allowedRoles, allowedUserIds, allowedCompanyIds, blockedCompanyIdsByRole, companyOverrides }) => {
  const token = localStorage.getItem("token");
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" replace />;
  }
  const decodedToken = jwtDecode(token);

  if (allowedRoles && !allowedRoles.includes(decodedToken?.userRole)) {
    return <Navigate to={getProtectedFallback(location, decodedToken)} replace />;
  }

  if (allowedUserIds && !allowedUserIds.includes(decodedToken?.userId)) {
    return <Navigate to={getProtectedFallback(location, decodedToken)} replace />;
  }

  if (allowedCompanyIds && !allowedCompanyIds.includes(decodedToken?.companyId)) {
    return <Navigate to={getProtectedFallback(location, decodedToken)} replace />;
  }

  if (blockedCompanyIdsByRole?.[decodedToken?.userRole]?.includes(decodedToken?.companyId)) {
    return <Navigate to={getProtectedFallback(location, decodedToken)} replace />;
  }

  if (companyOverrides && companyOverrides[decodedToken?.companyId]) {
    return companyOverrides[decodedToken?.companyId];
  }

  return element;
};

export const RoleBasedRedirect = () => {
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : "";
  const defaultRoute = getDefaultRouteForUser(decodedToken);

  if (defaultRoute) return <Navigate to={defaultRoute} replace />;

  return (
    <div>
      No valid role. Redirecting to login...
      <Navigate to="/demo/audio/upload-file" replace />
    </div>
  );
};
